import { render, staticRenderFns } from "./products-input.vue?vue&type=template&id=129d47a9&"
import script from "./products-input.vue?vue&type=script&lang=js&"
export * from "./products-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports